/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recent_Sales_DescriptionInputs */

const fr_recent_sales_description = /** @type {(inputs: Recent_Sales_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouvez ici les ventes récentes de vos programmes et produits. Vous pouvez également gérer les abonnements de vos utilisateurs.`)
};

/**

* @param {Recent_Sales_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const recent_sales_description = /** @type {((inputs?: Recent_Sales_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_Sales_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_recent_sales_description(inputs)
});